import { UserServiceClient } from 'fitbeat.api-clients';
import { IOauthParams } from 'fitbeat.models';
import { Logger } from '../../utils/Logger';
import {
  garminConnectAcceptedAuthorizationFailure,
  garminConnectAcceptedAuthorizationRequest,
  garminConnectAcceptedAuthorizationSuccess,
} from '../actions';

export const setUserGarminWorkoutImportConfig = (
  userServiceClient: UserServiceClient,
  data: IOauthParams,
) => async (dispatch) => {
  try {
    dispatch(garminConnectAcceptedAuthorizationRequest());
    const response = await userServiceClient.completeGarminConnectAuthorization(data);
    dispatch(garminConnectAcceptedAuthorizationSuccess(response));
  } catch (error) {
    Logger.notify(error);
    dispatch(garminConnectAcceptedAuthorizationFailure());
  }
};
